import React, { Component } from 'react';
import { connect } from 'react-redux';

class BootstrapSuccessError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: false,
    };
  }

  componentDidMount() {
    const { timeout } = this.props;
    if (!timeout) {
      setTimeout(() => {
        this.setState({ timeout: true });
      }, 3000);
    }
  }
  componentWillUnmount() {
    const { timeout } = this.props;
    clearTimeout(timeout);
  }

  render() {
    const {
      type,
      message,
      dataLocale: { ERROR, SUCCESS, SYMBOL_EXCLAIMATION },
    } = this.props;
    return (
      <React.Fragment>
        {!this.state.timeout && (
          <React.Fragment>
            {type === 'error' && (
              <div className="col-md-12 alert alert-danger">
                <strong className="text-capitalize" style={{ color: '#a94442' }}>
                  {ERROR}
                  {SYMBOL_EXCLAIMATION}{' '}
                </strong>
                {message}
              </div>
            )}
            {type === 'success' && (
              <div className="col-md-12 alert alert-success">
                <strong className="text-capitalize">
                  {SUCCESS}
                  {SYMBOL_EXCLAIMATION}{' '}
                </strong>
                {message}
              </div>
            )}
            {type === 'warning' && <div className="col-md-12 alert alert-warning">{message}</div>}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  dataLocale: state.locale,
});

export default connect(mapStateToProps, null)(BootstrapSuccessError);
